var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6702 4.67717C21.4543 1.10761 26.5457 1.10761 28.3298 4.67717L45.48 38.9901C47.0901 42.2117 44.7478 46 41.1502 46H6.84983C3.25219 46 0.909849 42.2117 2.52004 38.9901L19.6702 4.67717Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8352 39.6C24.8293 39.6 25.6352 38.7941 25.6352 37.8C25.6352 36.8059 24.8293 36 23.8352 36C22.841 36 22.0352 36.8059 22.0352 37.8C22.0352 38.7941 22.841 39.6 23.8352 39.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3609 20.6907C21.2402 19.2422 22.3833 18 23.8367 18C25.2902 18 26.4332 19.2422 26.3125 20.6907L25.4613 30.9052C25.3909 31.7501 24.6846 32.4 23.8367 32.4C22.9889 32.4 22.2826 31.7501 22.2122 30.9052L21.3609 20.6907Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningOutline);
export default __webpack_public_path__ + "static/media/icon-warning-outline.e7571a729f205c8b7d2f5a1acda463b2.svg";
export { ForwardRef as ReactComponent };